export default "__VITE_ASSET__Dag44_DT__"